module.exports = __webpack_public_path__ + "img/branchtobranch.fw.a35888ab.png";